module.exports = __webpack_public_path__ + "static/media/washingMachine.8ab8097f.svg";